import { defineMessages } from "react-intl";
export var messages = defineMessages({
  languageSelectorLabel: {
    id: "jutro-components.widgets.LanguageSelector.languageswitcher",
    defaultMessage: "Selected language"
  }
});